import { createApp } from "vue";
import App from "./App.vue";
import "@/assets/styles/index.scss";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import CountTo from "vue-countup-v3";
import Number from "@/components/number/index.vue";
import bgNumber from "@/components/bgNumber/index.vue";
import router from "./router";
import store from "@/views/store/index.js";
import "video.js/dist/video-js.css";
// import Echarts from "vue-echarts";
// import * as echarts from "echarts";

const app = createApp(App);
app.use(ElementPlus);
app.use(router);
app.use(store);
// app.component("e-charts", Echarts);
// app.config.globalProperties.$echarts = echarts;
app.component("countTo", CountTo);
app.component("Number", Number);
app.component("bgNumber", bgNumber);
app.mount("#app");
